export class SaveStudentAttendancePredictionRequest {
  schoolId: number;
  exerciseId: number;
  serviceId: number;
  predictionDate: string;
  primarySchool: number;
  middleSchool: number;
  highSchool: number;
}
